import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {environment} from '../../../environments/environment';
import {MatButtonModule} from '@angular/material/button';
import {clearIndexKeysFromCache, unregisterServiceWorker} from '@shared/util/cache-util';
import { AppLayoutFacadeService } from '../app-layout-facade.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-app-about',
    templateUrl: './app-about.component.html',
    styleUrls: ['./app-about.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatIconModule, MatDividerModule, MatButtonModule, AsyncPipe]
})
export class AppAboutComponent implements OnInit {
  version: string;
  cabangaLite$;

  constructor(private appLayoutFacade: AppLayoutFacadeService) { }

  ngOnInit() {
    this.version = environment.gitTag || environment.gitCommitId;
    this.cabangaLite$ = this.appLayoutFacade.cabangaLite$;
  }

  async refreshApp() {
    await clearIndexKeysFromCache();
    await unregisterServiceWorker();
    window.location.reload();
  }
}
